import { render, staticRenderFns } from "./RevokeDialog.vue?vue&type=template&id=0a96793a"
import script from "./RevokeDialog.vue?vue&type=script&lang=js"
export * from "./RevokeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports